"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_parameters_1 = require("@pulse-web-platform-core/app-parameters");
const theme_container_in_1 = require("./theme-container-in");
const ThemeContainer = ({ setAppLoading, appLoading, setAppConfig, productName, onPresetLoaded, children, }) => {
    const { personalization, preset } = (0, app_parameters_1.useConfig)();
    return ((0, jsx_runtime_1.jsx)(theme_container_in_1.ThemeContainerIn, { setAppLoading: setAppLoading, appLoading: appLoading, setAppConfig: setAppConfig, personalization: personalization, productName: productName, onPresetLoaded: onPresetLoaded, preset: preset, children: children }));
};
exports.ThemeContainer = ThemeContainer;
